import { ElementRef } from '@angular/core';
import { Selectors } from 'src/app/data/enum/selectors';
import gsap from 'gsap';

export default (pageRef: ElementRef, disableRemoteAnimation: boolean = false): GSAPTimeline => {
  const coreTimeline = gsap.timeline({ paused: true });
  const parentElement = pageRef.nativeElement;
  const parentChildrenSelector = gsap.utils.selector(parentElement);

  // Remote control component animation
  const remoteControlTimeline: () => GSAPTimeline = () => {
    const timeline = gsap.timeline();
    const remoteControl = parentChildrenSelector(Selectors.REMOTE_WRAPPER);

    timeline.to(remoteControl, { autoAlpha: 0, duration: 0.1 });
    return timeline;
  };

  // End Screen component animation
  const EndScreenTimeline: () => GSAPTimeline = () => {
    const timeline = gsap.timeline();
    const endScreen = parentChildrenSelector(Selectors.ENDSCREEN_WRAPPER);
    const title = parentChildrenSelector(Selectors.ENDSCREEN_TITLE);
    const subtitle = parentChildrenSelector(Selectors.ENDSCREEN_COPY);
    const buttons = parentChildrenSelector(Selectors.ENDSCREEN_BUTTONS_WRAPPER);
    const disclaimer = parentChildrenSelector(Selectors.DISCLAIMER);

    timeline
      .to(endScreen, { autoAlpha: 1, duration: 1.5 }, 0)
      .to(
        disclaimer,
        {
          autoAlpha: 0,
          duration: 0.1,
        },
        0,
      )
      .fromTo(title, { autoAlpha: 0, y: '50%' }, { autoAlpha: 1, y: '50%', duration: 0.75 }, '-=1')
      .to(title, { y: 0, duration: 0.5, ease: 'power2.out' }, '+=1')
      .addLabel('scene2', '-=0.5')
      .fromTo(
        subtitle,
        { autoAlpha: 0 },
        { autoAlpha: 1, ease: 'power2.out', duration: 1, y: 0 },
        'scene2',
      )
      .fromTo(
        buttons,
        { autoAlpha: 0, y: '-50%' },
        { autoAlpha: 1, ease: 'power2.out', duration: 0.75, y: 0 },
        'scene2',
      );
    return timeline;
  };

  if (!disableRemoteAnimation) {
    coreTimeline.add(remoteControlTimeline(), 0);
  }
  coreTimeline.add(EndScreenTimeline());

  return coreTimeline;
};
